<template>
  <div
    :class="[isinput ? 'selected_status' : 'unselected_status', 'button']"
    @click="onSubmit"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: ["isinput", "text"],

  methods: {
    // 点击确定传送时间
    onSubmit() {
      if(!this.isinput){
        return;
      }
      this.$emit('onSubmit')
    },
  },
};
</script>

<style scoped>
.button {
  width: 419px;
  margin-top: 20px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  border-radius: 4px;
  font-size: 16px;
}
.selected_status {
  background: #1E40AF;
  color: white;
  cursor: pointer;
}
.unselected_status {
  background: rgba(0, 88, 255, 0.5);
  color: #ffffff;
}
</style>
